import React from 'react';

interface OfferCodeProps {
  offerCode: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'highlighted';
  label?: string;
  id?: string;
  name?: string;
}

export default function OfferCode({
  offerCode,
  className = '',
  size = 'md',
  variant = 'default',
  label = 'Offer Code',
  id,
  name
}: OfferCodeProps) {
  const sizeStyles = {
    sm: {
      container: 'px-3 py-1.5',
      label: 'text-sm',
      code: 'text-xl'
    },
    md: {
      container: 'px-4 py-2',
      label: 'text-base',
      code: 'text-3xl'
    },
    lg: {
      container: 'px-6 py-3',
      label: 'text-lg',
      code: 'text-4xl'
    }
  };

  const variantStyles = {
    default: 'bg-[#b3905e]/10 border-2 border-[#b3905e]/30',
    highlighted: 'bg-gradient-to-r from-[#b3905e]/20 to-[#212d52]/20 border-2 border-[#b3905e]/50 shadow-lg'
  };

  const currentSize = sizeStyles[size];
  const currentVariant = variantStyles[variant];

  return (
    <div 
      className={`${currentVariant} rounded-xl ${currentSize.container} mb-3 ${className}`}
      id={id}
      data-name={name}
    >
      <div className="text-center">
        <p className={`${currentSize.label} text-[#b3905e] font-semibold mb-2 uppercase tracking-wide`}>
          {label}
        </p>
        <p className={`${currentSize.code} font-black text-[#b3905e] tracking-wider`}>
          {offerCode}
        </p>
      </div>
    </div>
  );
}